import React from 'react';

export const MainContentWrapper = ({ id = "contain", maxWidthHandler = true, mainClass = "" , isSimulator = false, children }) => {
  let content = null;

  // TODO: da rivedere in un modo migliore
  if (isSimulator) {
    content = (<div className="loan-middle-scp">{ children }</div>);
  } else {
    content = children;
  }
  
  return (
    <section id={id} className={`${mainClass ? mainClass : ""}`}>
    	<div className={`loan-block-rpp ${ isSimulator || !maxWidthHandler ? 'loan-block-scp' : '' }`}>
        <div className="container">
          <div className="row">
            <div className={`${mainClass ? mainClass : "col-12 loan-block-in-rpp"}`}>
              { content }
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
